import {FireInTheHole2} from "../../../FireInTheHole2";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";
import {TweenLite, gsap} from "gsap";
import {FreespinTrainView} from "./FreespinTrainView";
import {FreespinTrainSymbol} from "../../../symbols/freespin/train/FreespinTrainSymbol";
import {IFsSymbolData} from "../../../symbols/freespin/FreespinSymbol";
import {FITH2SoundManager} from "../../../sound/FITH2SoundManager";

export class SideTrainView extends FreespinTrainView {
    constructor(id: number) {
        super(id);
        this.name = "sideTrain";
    }

    public initReel(symbols: IFsSymbolData[]): void {
        for (let i: number = 0; i < symbols.length; i++) {
            const symbol: FreespinTrainSymbol = this.createSymbol(symbols[i]);
            symbol.position.set(0, 100 * i);
            this._allSymbols.push(symbol);
        }
    }

    public show(reelData: IFsSymbolData[],isFromIntro:boolean): void {
        this._container.position.y = 215;
        this._allSymbols.forEach((symbol: FreespinTrainSymbol, i: number) => {
            symbol.position.set(0, 100 * i);
            if(isFromIntro){
                symbol.show(reelData[i]);
            }
            this._container.addChild(symbol);
        });
    }

    public stop(reelData: IFsSymbolData[], duration: number): gsap.core.Timeline {
        this._container.position.y = 1215;
        const tl = gsap.timeline().add(TweenLite.to(this._container, duration, {y: 215}));
        this._allSymbols.forEach((symbol: FreespinTrainSymbol, i: number) => {
            symbol.stop(reelData[i]);
            if (reelData[i].symName === "H") {
                tl.add([
                    symbol.stopped(true),
                    () => {
                        FITH2SoundManager.playUpgradeSymbolLandingSound();
                        FireInTheHole2.freespinReelArea.onSideTrainSymbolLand(i)
                    }]);
                if (i > 1) {
                    let isDirtRow: boolean = true;
                    for (let s: number = 0; s < 6; s++) {
                        if (FireInTheHole2.model.reels[s][i + 1] != "D") {
                            isDirtRow = false
                        }
                    }
                    if (isDirtRow) {
                        tl.add(symbol.darkDown());
                    }
                }
            }
        });
        return tl;
    }

    public spin(delay: number, hasAnticipation: boolean): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(TweenLite.to(this._container, 1, {y: -785}));
        return tl;
    }

    public trigger(rowId: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(this._allSymbols[rowId].upgrade());
        return tl;
    }

    get isFastSpin(): boolean {
        const fastSpin: boolean = FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN, false);
        return fastSpin;
    }
}